/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { UnitType } from '@trebox-data/knowledge-resource-processor-core';
import { KnowledgeE2e } from '@trebox-data/e2e';
import { I18n } from '@trebox-arch/i18n';
import { IconCozDocument } from '@coze-arch/coze-design/icons';

import { SourceRadio } from '../../../components/source-radio';

export const TextLocal = () => (
  <SourceRadio
    title={I18n.t('datasets_createFileModel_step1_LocalTitle')}
    description={I18n.t('datasets_createFileModel_step1_LocalDescription')}
    icon={<IconCozDocument className="w-4 h-4" />}
    e2e={KnowledgeE2e.CreateKnowledgeModalTextLocalRadio}
    key={UnitType.TEXT_DOC}
    value={UnitType.TEXT_DOC}
  />
);
